import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFontBold = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 20 20",
	width: 20,
	height: 20,
	fill: "none",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		stroke: "#71717A",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 2,
		d: "M5.834 10h4.167a2.917 2.917 0 0 0 0-5.834H6.478c-.212 0-.318 0-.4.038a.417.417 0 0 0-.206.206c-.038.082-.038.188-.038.4V10Zm0 0h5.417a2.917 2.917 0 0 1 0 5.833H6.5c-.234 0-.35 0-.44-.046a.417.417 0 0 1-.182-.182c-.045-.089-.045-.206-.045-.439V9.999Z"
	})
});
const ForwardRef = forwardRef(SvgFontBold);
export default ForwardRef;
